(function () {
  var wrapper = document.querySelector('.lp');
  if (!wrapper) return;

  /* ===== PRICING DATA ===== */
  var FRESH = {
    bouquet: 350, bridesmaid: 85, centerpiece: 120,
    arch: 800, bout: 22, cake: 250, hair: 95, aisle: 45
  };
  var SOLA = {
    bouquet: 120, bridesmaid: 45, centerpiece: 40,
    arch: 250, bout: 8, cake: 80, hair: 35, aisle: 15
  };

  function guestScale(g) {
    var bm = Math.max(1, Math.round(g / 30));
    var cp = Math.max(1, Math.round(g / 20));
    var bt = Math.max(2, Math.round(g / 25));
    return { bm: bm, cp: cp, bt: bt };
  }

  /* ===== REFRAME LINES ===== */
  var reframes = [
    { i: '💐', t: 'That\'s {n} extra bouquets for bridesmaids' },
    { i: '✈️', t: 'That covers a honeymoon flight for two' },
    { i: '📸', t: 'Enough for a premium wedding photographer' },
    { i: '🎂', t: 'That\'s a dream wedding cake — paid in full' },
    { i: '🎶', t: 'A live band for your reception, covered' },
    { i: '👗', t: 'That covers your dream wedding dress' },
    { i: '🍽️', t: 'That\'s {n} extra guests at the reception' },
    { i: '💍', t: 'Put that toward the ring upgrade' }
  ];
  var rfIdx = 0;

  /* ===== DOM REFS ===== */
  var slider = document.getElementById('slider');
  var gNum = document.getElementById('gNum');
  var badge = document.getElementById('badge');
  var heroAmt = document.getElementById('heroAmt');
  var fT = document.getElementById('fT');
  var sT = document.getElementById('sT');
  var sAmt = document.getElementById('sAmt');
  var sPct = document.getElementById('sPct');
  var rfI = document.getElementById('rfI');
  var rfT = document.getElementById('rfT');
  var stickyEl = document.getElementById('sticky');
  var stickyLine = document.getElementById('stickyLine');
  var eG = document.getElementById('eG');

  /* breakdown refs */
  var xfB = document.getElementById('xfB');
  var xsB = document.getElementById('xsB');
  var xfBm = document.getElementById('xfBm');
  var xsBm = document.getElementById('xsBm');
  var xlBm = document.getElementById('xlBm');
  var xfCp = document.getElementById('xfCp');
  var xsCp = document.getElementById('xsCp');
  var xlCp = document.getElementById('xlCp');
  var xfA = document.getElementById('xfA');
  var xsA = document.getElementById('xsA');
  var xfBt = document.getElementById('xfBt');
  var xsBt = document.getElementById('xsBt');
  var xlBt = document.getElementById('xlBt');
  var xfCk = document.getElementById('xfCk');
  var xsCk = document.getElementById('xsCk');
  var xfHr = document.getElementById('xfHr');
  var xsHr = document.getElementById('xsHr');
  var xfAi = document.getElementById('xfAi');
  var xsAi = document.getElementById('xsAi');
  var xfT = document.getElementById('xfT');
  var xsT = document.getElementById('xsT');

  function $(n) { return '$' + n.toLocaleString(); }

  function update(g) {
    var s = guestScale(g);
    gNum.textContent = g;
    if (eG) eG.textContent = g;

    /* badge */
    badge.className = 'size-badge ' + (g <= 50 ? 'intimate' : g <= 150 ? 'classic' : 'grand');
    badge.textContent = g <= 50 ? 'Intimate' : g <= 150 ? 'Classic' : 'Grand';

    /* totals */
    var freshTotal = FRESH.bouquet + FRESH.bridesmaid * s.bm + FRESH.centerpiece * s.cp +
      FRESH.arch + FRESH.bout * s.bt + FRESH.cake + FRESH.hair + FRESH.aisle * 6;
    var solaTotal = SOLA.bouquet + SOLA.bridesmaid * s.bm + SOLA.centerpiece * s.cp +
      SOLA.arch + SOLA.bout * s.bt + SOLA.cake + SOLA.hair + SOLA.aisle * 6;
    var saved = freshTotal - solaTotal;
    var pct = Math.round((saved / freshTotal) * 100);

    fT.textContent = $(freshTotal);
    sT.textContent = $(solaTotal);
    heroAmt.textContent = $(saved);
    sAmt.textContent = $(saved);
    sPct.textContent = pct;

    /* slider track fill */
    var p = ((g - 10) / (300 - 10)) * 100;
    slider.style.setProperty('--p', p + '%');

    /* reframe */
    var rf = reframes[rfIdx % reframes.length];
    var txt = rf.t.replace('{n}', Math.round(saved / 120));
    rfI.classList.add('swap');
    rfT.classList.add('swap');
    setTimeout(function () {
      rfI.textContent = rf.i;
      rfT.textContent = txt;
      rfI.classList.remove('swap');
      rfT.classList.remove('swap');
    }, 250);
    rfIdx++;

    /* savings pulse */
    sAmt.classList.remove('pulse');
    void sAmt.offsetWidth;
    sAmt.classList.add('pulse');

    /* sticky */
    if (stickyLine) stickyLine.textContent = 'You save ' + $(saved);

    /* breakdown table */
    if (xfB) {
      xfB.textContent = $(FRESH.bouquet);
      xsB.textContent = $(SOLA.bouquet);
      xfBm.textContent = $(FRESH.bridesmaid * s.bm);
      xsBm.textContent = $(SOLA.bridesmaid * s.bm);
      xlBm.textContent = 'Bridesmaid Bouquets (' + s.bm + ')';
      xfCp.textContent = $(FRESH.centerpiece * s.cp);
      xsCp.textContent = $(SOLA.centerpiece * s.cp);
      xlCp.textContent = 'Centerpieces (' + s.cp + ')';
      xfA.textContent = $(FRESH.arch);
      xsA.textContent = $(SOLA.arch);
      xfBt.textContent = $(FRESH.bout * s.bt);
      xsBt.textContent = $(SOLA.bout * s.bt);
      xlBt.textContent = 'Boutonnieres & Corsages (' + s.bt + ')';
      xfCk.textContent = $(FRESH.cake);
      xsCk.textContent = $(SOLA.cake);
      xfHr.textContent = $(FRESH.hair);
      xsHr.textContent = $(SOLA.hair);
      xfAi.textContent = $(FRESH.aisle * 6);
      xsAi.textContent = $(SOLA.aisle * 6);
      xfT.textContent = $(freshTotal);
      xsT.textContent = $(solaTotal);
    }
  }

  /* ===== SLIDER ===== */
  if (slider) {
    slider.addEventListener('input', function () { update(parseInt(this.value)); });
    update(100);
  }

  /* ===== FAQ ACCORDION ===== */
  wrapper.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var answer = this.nextElementSibling;
      var isOpen = this.classList.contains('open');
      /* close all */
      wrapper.querySelectorAll('.faq-q.open').forEach(function (q) {
        q.classList.remove('open');
        q.nextElementSibling.classList.remove('open');
      });
      if (!isOpen) {
        this.classList.add('open');
        answer.classList.add('open');
      }
    });
  });

  /* ===== BREAKDOWN TOGGLE ===== */
  var bdToggle = document.getElementById('bdToggle');
  var bdContent = document.getElementById('bdContent');
  if (bdToggle && bdContent) {
    bdToggle.addEventListener('click', function () {
      bdToggle.classList.toggle('open');
      bdContent.classList.toggle('open');
    });
  }

  /* ===== EMAIL FORM ===== */
  var eTrig = document.getElementById('eTrig');
  var eForm = document.getElementById('eForm');
  var eBtn = document.getElementById('eBtn');
  var eIn = document.getElementById('eIn');
  var eOk = document.getElementById('eOk');
  if (eTrig && eForm) {
    eTrig.addEventListener('click', function () { eForm.classList.toggle('open'); });
  }
  if (eBtn && eIn && eOk) {
    eBtn.addEventListener('click', function () {
      if (eIn.value && eIn.value.includes('@')) {
        eForm.style.display = 'none';
        eTrig.style.display = 'none';
        eOk.classList.add('show');
      }
    });
  }

  /* ===== LIVE VIEWER COUNT ===== */
  var viewers = document.getElementById('viewers');
  if (viewers) {
    setInterval(function () {
      var v = parseInt(viewers.textContent) + Math.floor(Math.random() * 5) - 2;
      viewers.textContent = Math.max(14, Math.min(48, v));
    }, 4000);
  }

  /* ===== STICKY CTA SHOW ON SCROLL ===== */
  if (stickyEl) {
    var heroEl = wrapper.querySelector('.hero');
    if (heroEl) {
      window.addEventListener('scroll', function () {
        var rect = heroEl.getBoundingClientRect();
        stickyEl.style.display = rect.bottom < 0 ? 'block' : 'none';
      }, { passive: true });
    }
  }
})();
